






























































import { Component } from "vue-property-decorator";
import axios from "axios";
import Paginater from "@/components/Paginater.vue";
import HacoBase from "../HacoBase";

@Component({
  components: {
    Paginater
  }
})
export default class GlueList extends HacoBase {
  editData: {} = {};
  $debugServer!: string;
  locale = "en";

  mounted(): void {
    this.locale = this.$i18n.locale;
    this.loadListData();
  }

  loadListData(pagedUrl = ""): void {
    const url =
      pagedUrl === "" ? this.$debugServer + "/api/v1_inner/glue" : pagedUrl;
    const params: object = this.setAxiosParams(url, "get");
    // データ取ってくる
    axios(params)
      .then((response: any): void => {
        this.editData = response.data.glue;
        this.putPageData(response.data.paginate);
      })
      .catch((error: any): void => {
        console.log("[error]", error.response);
        this.toLoginPage(error);
      });
  }

  movePage(page: string | number): void {
    if (this.pagination.currentPage === page) {
      return;
    }
    this.loadListData(this.getPage(page));
  }

  openEditPage(id: number): void {
    this.$router.push({
      name: "GlueEdit",
      params: { id: id.toString() }
    });
  }
}
